import React, { useMemo } from 'react';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getDisponibilidadeMotoristaColumns } from './tanStackColumnsMotorista';
import { getMotoristaRowId } from '../utils/mappers';

const DisponibilidadeMotoristaTable = ({
  data,
  loading,
  totalRegistros,
  paginaAtual,
  quantidadePorPagina,
  setPaginaAtual,
  setQuantidadePorPagina,
  enableCardView = false,
  defaultViewMode = 'table',
  renderCard,
  onRowClick,
  columnConfigKey = 'disponibilidade-frota-patio-motorista-columns'
}) => {
  const pageIndex = Math.max(0, (paginaAtual || 1) - 1);
  const pageSize = quantidadePorPagina || 5;
  const paginatedData = useMemo(() => {
    const start = pageIndex * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, pageIndex, pageSize]);

  return (
    <TanStackTable
      columns={getDisponibilidadeMotoristaColumns()}
      data={paginatedData}
      getRowId={getMotoristaRowId}
      isSortable={true}
      withPagination={true}
      pageSizeOptions={[5, 10, 25, 50, 100]}
      enableRowColors={true}
      loading={!!loading}
      className="mt-3"
      manualPagination={true}
      totalItems={totalRegistros}
      enableColumnConfig={true}
      columnConfigKey={columnConfigKey}
      enableCardView={enableCardView}
      enableCopy={true}
      defaultViewMode={defaultViewMode}
      renderCard={renderCard}
      onRowClick={onRowClick}
      controlledPagination={{
        pageIndex,
        pageSize
      }}
      onPaginationChange={next => {
        if (next && typeof next.pageSize === 'number') {
          setQuantidadePorPagina(next.pageSize);
        }

        if (next && typeof next.pageIndex === 'number') {
          setPaginaAtual(next.pageIndex + 1);
        }
      }}
    />
  );
};

export default DisponibilidadeMotoristaTable;
